/**
 * FR-449: Approved tooltip copy for Studio tool buttons.
 * Source: "Design Studio Tool Tips and Updates" Google Doc.
 *
 * Keyed by tool name (matching the `label` prop on ToolsToolButton).
 * Entries are the hover description text shown in the tooltip.
 */
export const TOOLTIP_COPY: Record<string, string> = {
  // Tile Tools
  Add: "Place a new tile on the canvas",
  Select: "Click tiles to select and then edit or move them",
  Undo: "Reverse your last action",
  Redo: "Reapply the last undone action",
  Delete: "Remove the selected tile(s)",
  "To Front": "Move selected tile in front of overlapping tiles",
  "To Back": "Move selected tile behind overlapping tiles",
  Preview: "See a clean preview of your design",
  "Select All": "Select every tile on the canvas",
  Lasso: "Draw a selection around tiles",
  Copy: "Copy the selected tile(s)",
  Cut: "Cut the selected tile(s) to paste elsewhere",

  // Grid Tools
  Move: "Pan around the canvas",
  "Grid Size": "Adjust the size of the design grid",
  "Change Grid": "Switch between grid layouts or configurations",
  "Zoom in": "Get a closer view of your design",
  "Zoom out": "Zoom out to see more of the canvas",

  // Project Tools
  New: "Start a fresh design",
  Import: "Open a previously saved design by entering in its Design ID",
  Save: "Save your current design",
  "Save As": "Save a copy of your design with a new name",
  "View in Room": "Preview how your design looks in a room setting",
  Settings: "Adjust project or studio settings",
  Share: "Share your design with others",
  "My Designs": "Browse all your saved designs",
  Logout: "Sign out of your account",
  Login: "Sign in to your account",

  // Cart
  "Add to Cart": "Add the current design to your cart",
} as const;

import { FR_COLORS } from "./useBrandColors";

export const TOOLTIP_BG = FR_COLORS.LIGHT_BLUE;
export const TOOLTIP_TEXT = "#FFFFFF";
